<div class="bg-white flex flex-col overflow-hidden h-full">
  <div class="p-2 border-bottom flex flex-col gap-2">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label>{{ 'catalog.facet_timeline.date_range' | transloco }}</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input [(ngModel)]="startDate" matStartDate placeholder="Start date">
        <input [(ngModel)]="endDate" matEndDate placeholder="End date">
      </mat-date-range-input>
      <mat-datepicker-toggle [for]="picker" matIconSuffix></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

    <div class="flex gap-2">
      <mat-form-field class="flex-auto" subscriptSizing="dynamic">
        <mat-label>{{ 'catalog.facet_timeline.interval_name' | transloco }}</mat-label>
        <mat-select [(ngModel)]="intervalName">
          @for (interval of intervals; track interval) {
            <mat-option [value]="interval">
              {{ 'catalog.facet_timeline.intervals.' + interval | transloco }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field subscriptSizing="dynamic">
        <mat-label>{{ 'catalog.facet_timeline.interval_value' | transloco }}</mat-label>
        <input [(ngModel)]="intervalValue" matInput type="number"/>
      </mat-form-field>
    </div>
  </div>

  <div class="p-2 flex-auto overflow-auto">
    <div
      [innerHTML]="'catalog.facet_timeline.before_count' | transloco: {value: beforeCount()}"
      class="py-1 text-gray-500 text-center mat-body-small">
    </div>
    <cat-timeline-bar-chart [intervalName]="intervalName()" [intervalValue]="intervalValue()" [items]="items()"
                            [range]="range()"></cat-timeline-bar-chart>
    <div
      [innerHTML]="'catalog.facet_timeline.after_count' | transloco: {value: afterCount()}"
      class="py-1 text-gray-500 text-center mat-body-small">
    </div>
  </div>

  <div class="p-2 flex flex-col gap-2 border-top">
    <div class="justify-self-stretch flex">
      <mat-slider [max]="items().length-1" class="flex-auto" min="0" showTickMarks>
        <input [(ngModel)]="start" matSliderStartThumb>
        <input [(ngModel)]="end" matSliderEndThumb>
      </mat-slider>
    </div>
    <div class="flex justify-center">
      <button (click)="onSearch()" [loading]="loading$ | async" mat-flat-button>
        <mat-icon>search</mat-icon>
        {{ facetItem?.timelineResultCount }}
        @if (rangeLabel(); as rangeLabel) {
          ({{ rangeLabel }})
        }
      </button>
    </div>
  </div>
</div>

<!--
<cat-timeline-bar-chart (onFilter)="onFilter($event)" [animations]="animations" [gradient]="gradient"
                        [noBarWhenZero]="noBarWhenZero"
                        [results]="data"
                        [schemeType]="schemeType"
                        [scheme]="colorScheme"
                        [showGridLines]="showGridLines"
                        [showXAxisLabel]="false"
                        [showYAxisLabel]="showYAxisLabel"
                        [view]="view"
                        [xAxisLabel]="xAxisLabel"
                        [xAxis]="showXAxis"
                        [yAxisLabel]="'Executions'"
                        [yAxis]="showYAxis"></cat-timeline-bar-chart>
-->
